{
  "about.blocks": "Moderirani poslužitelji",
  "about.contact": "Kontakt:",
  "about.disclaimer": "Mastodon je besplatan softver otvorenog koda i zaštitni znak tvrtke Mastodon gGmbH.",
  "about.domain_blocks.no_reason_available": "Razlog nije dostupan",
  "about.domain_blocks.preamble": "Mastodon vam općenito omogućuje pregled sadržaja i interakciju s korisnicima s bilo kojeg drugog poslužitelja u fediverse. Ovo su iznimke napravljene na ovom poslužitelju.",
  "about.domain_blocks.silenced.explanation": "Obično nećete vidjeti profile i sadržaj s ovog poslužitelja, osim ako ga izričito ne potražite ili uključite u njega slijedeći ga.",
  "about.domain_blocks.silenced.title": "Ograničen",
  "about.domain_blocks.suspended.explanation": "Podatci s ovog poslužitelja neće se obrađivati, pohranjivati ili razmjenjivati, što onemogućuje bilo kakvu interakciju ili komunikaciju s korisnicima s ovog poslužitelja.",
  "about.domain_blocks.suspended.title": "Suspendiran",
  "about.language_label": "Jezik",
  "about.not_available": "Te informacije nisu dostupne na ovom poslužitelju.",
  "about.powered_by": "Decentralizirani društveni mediji koje pokreće {mastodon}",
  "about.rules": "Pravila servera",
  "account.activity": "Aktivnost",
  "account.add_or_remove_from_list": "Dodaj ili ukloni s liste",
  "account.badges.admin": "Admin",
  "account.badges.bot": "Bot",
  "account.badges.group": "Grupa",
  "account.block": "Blokiraj @{name}",
  "account.block_domain": "Blokiraj domenu {domain}",
  "account.block_short": "Blokiraj",
  "account.blocked": "Blokirano",
  "account.cancel_follow_request": "Withdraw follow request",
  "account.copy": "Kopiraj vezu u profil",
  "account.direct": "Privatno spomeni @{name}",
  "account.disable_notifications": "Nemoj me obavjestiti kada @{name} napravi objavu",
  "account.edit_profile": "Uredi profil",
  "account.edit_profile_short": "Uredi",
  "account.enable_notifications": "Obavjesti me kada @{name} napravi objavu",
  "account.endorse": "Istakni na profilu",
  "account.follow": "Prati",
  "account.follow_back": "Slijedi natrag",
  "account.follow_request_cancel": "Poništi zahtjev",
  "account.follow_request_cancel_short": "Odustani",
  "account.follow_request_short": "Zatraži",
  "account.followers": "Pratitelji",
  "account.followers.empty": "Nitko još ne prati korisnika/cu.",
  "account.following": "Pratim",
  "account.follows.empty": "Korisnik/ca još ne prati nikoga.",
  "account.go_to_profile": "Idi na profil",
  "account.hide_reblogs": "Sakrij boostove od @{name}",
  "account.in_memoriam": "U sjećanje.",
  "account.joined_short": "Pridružen",
  "account.languages": "Promjeni pretplaćene jezike",
  "account.link_verified_on": "Vlasništvo ove poveznice provjereno je {date}",
  "account.locked_info": "Status privatnosti ovog računa postavljen je na zaključano. Vlasnik ručno pregledava tko ih može pratiti.",
  "account.media": "Medijski sadržaj",
  "account.mention": "Spomeni @{name}",
  "account.menu.block": "Blokiraj račun",
  "account.menu.block_domain": "Blokiraj {domain}",
  "account.menu.copy": "Kopiraj poveznicu",
  "account.menu.mention": "Spomeni",
  "account.menu.remove_follower": "Ukloni pratitelja",
  "account.menu.report": "Prijavi račun",
  "account.mute": "Utišaj @{name}",
  "account.mute_notifications_short": "Utišaj obavijesti",
  "account.mute_short": "Utišaj",
  "account.muted": "Utišano",
  "account.no_bio": "Nije dan opis.",
  "account.node_modal.save": "Spremi",
  "account.note.edit_button": "Uredi",
  "account.open_original_page": "Otvori originalnu stranicu",
  "account.posts": "Objave",
  "account.report": "Prijavi @{name}",
  "account.requested_follow": "{name} zatražio/la je praćenje",
  "account.share": "Podijeli profil @{name}",
  "account.show_reblogs": "Prikaži boostove od @{name}",
  "account.unblock": "Deblokiraj @{name}",
  "account.unblock_domain": "Deblokiraj domenu {domain}",
  "account.unblock_short": "Deblokiraj",
  "account.unendorse": "Ne ističi na profilu",
  "account.unfollow": "Prestani pratiti",
  "account.unmute": "Poništi utišavanje @{name}",
  "account.unmute_notifications_short": "Uključi utišane obavijesti",
  "account.unmute_short": "Poništi utišavanje",
  "account_edit.bio.title": "Biografija",
  "account_edit.bio_modal.add_title": "Dodaj biografiju",
  "account_edit.bio_modal.edit_title": "Uredi biografiju",
  "account_edit.column_button": "Završi",
  "account_edit.column_title": "Uredi profil",
  "account_edit.custom_fields.title": "Prilagođena polja",
  "account_edit.featured_hashtags.title": "Istaknuti hashtagovi",
  "account_edit.save": "Spremi",
  "account_note.placeholder": "Kliknite za dodavanje bilješke",
  "admin.dashboard.daily_retention": "Stopa zadržavanja korisnika po danu nakon prijave",
  "admin.dashboard.monthly_retention": "Stopa zadržavanja korisnika po mjesecu nakon prijave",
  "admin.dashboard.retention.average": "Prosječno",
  "admin.dashboard.retention.cohort": "Mjesec prijave",
  "admin.dashboard.retention.cohort_size": "Novi korisnici",
  "admin.impact_report.instance_accounts": "Profili računa koji bi ovo izbrisali",
  "admin.impact_report.instance_followers": "Sljedbenici koje bi izgubili naši korisnici",
  "admin.impact_report.instance_follows": "Sljedbenici koje bi izgubili njihovi korisnici",
  "admin.impact_report.title": "Sažetak učinka",
  "alert.rate_limited.message": "Molimo pokušajte nakon {retry_time, time, medium}.",
  "alert.rate_limited.title": "Ograničenje učestalosti",
  "alert.unexpected.message": "Dogodila se neočekivana greška.",
  "alert.unexpected.title": "Ups!",
  "alt_text_badge.title": "Alternativni tekst",
  "alt_text_modal.add_alt_text": "Dodaj altenativni tekst",
  "alt_text_modal.add_text_from_image": "Dodaj tekst iz slike",
  "alt_text_modal.cancel": "Odustani",
  "alt_text_modal.done": "Gotovo",
  "announcement.announcement": "Najava",
  "annual_report.announcement.action_dismiss": "Ne hvala",
  "annual_report.nav_item.badge": "Novi",
  "annual_report.shared_page.donate": "Doniraj",
  "attachments_list.unprocessed": "(neobrađeno)",
  "audio.hide": "Sakrij audio",
  "boost_modal.combo": "Možete pritisnuti {combo} kako biste preskočili ovo sljedeći put",
  "bundle_column_error.copy_stacktrace": "Kopiraj izvješće o pogrešci",
  "bundle_column_error.error.body": "Zaraženu stranicu nije moguće prikazati. To bi moglo biti zbog pogreške u našem kodu ili problema s kompatibilnošću preglednika.",
  "bundle_column_error.error.title": "Oh, ne!",
  "bundle_column_error.network.body": "Došlo je do pogreške prilikom pokušaja učitavanja ove stranice. Razlog može biti privremeni problem s internetskom vezom ili ovim poslužiteljem.",
  "bundle_column_error.network.title": "Greška mreže",
  "bundle_column_error.retry": "Pokušajte ponovno",
  "bundle_column_error.return": "Na glavnu",
  "bundle_column_error.routing.body": "Traženu stranicu nije moguće pronaći. Jeste li sigurni da je URL u adresnoj traci točan?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Zatvori",
  "bundle_modal_error.retry": "Pokušajte ponovno",
  "closed_registrations_modal.find_another_server": "Nađi drugi server",
  "column.about": "O aplikaciji",
  "column.blocks": "Blokirani korisnici",
  "column.bookmarks": "Knjižne oznake",
  "column.community": "Lokalna vremenska crta",
  "column.direct": "Privatna spominjanja",
  "column.directory": "Pregledavanje profila",
  "column.domain_blocks": "Blokirane domene",
  "column.favourites": "Favoriti",
  "column.follow_requests": "Zahtjevi za praćenje",
  "column.home": "Početna",
  "column.lists": "Liste",
  "column.mutes": "Utišani korisnici",
  "column.notifications": "Obavijesti",
  "column.pins": "Prikvačeni tootovi",
  "column.public": "Federalna vremenska crta",
  "column_back_button.label": "Natrag",
  "column_header.hide_settings": "Sakrij postavke",
  "column_header.moveLeft_settings": "Pomakni stupac ulijevo",
  "column_header.moveRight_settings": "Pomakni stupac udesno",
  "column_header.pin": "Prikvači",
  "column_header.show_settings": "Prikaži postavke",
  "column_header.unpin": "Otkvači",
  "community.column_settings.local_only": "Samo lokalno",
  "community.column_settings.media_only": "Samo medijski sadržaj",
  "community.column_settings.remote_only": "Samo udaljeno",
  "compose.language.change": "Promijeni jezik",
  "compose.language.search": "Pretraži jezike...",
  "compose.published.body": "Post je objavljen.",
  "compose.published.open": "Otvori",
  "compose.saved.body": "Post spremljen.",
  "compose_form.direct_message_warning_learn_more": "Saznajte više",
  "compose_form.encryption_warning": "Posts on Mastodon are not end-to-end encrypted. Do not share any dangerous information over Mastodon.",
  "compose_form.hashtag_warning": "This post won't be listed under any hashtag as it is unlisted. Only public posts can be searched by hashtag.",
  "compose_form.lock_disclaimer": "Vaš račun nije {locked}. Svatko Vas može pratiti kako bi vidjeli objave namijenjene Vašim pratiteljima.",
  "compose_form.lock_disclaimer.lock": "zaključan",
  "compose_form.placeholder": "Što ti je na umu?",
  "compose_form.poll.duration": "Trajanje ankete",
  "compose_form.poll.switch_to_multiple": "Omogući višestruki odabir opcija ankete",
  "compose_form.poll.switch_to_single": "Omogući odabir samo jedne opcije ankete",
  "compose_form.spoiler.marked": "Tekst je skriven iza upozorenja",
  "compose_form.spoiler.unmarked": "Tekst nije skriven",
  "confirmation_modal.cancel": "Otkaži",
  "confirmations.block.confirm": "Blokiraj",
  "confirmations.delete.confirm": "Obriši",
  "confirmations.delete.message": "Stvarno želite obrisati ovaj toot?",
  "confirmations.delete_list.confirm": "Obriši",
  "confirmations.delete_list.message": "Jeste li sigurni da želite trajno obrisati ovu listu?",
  "confirmations.discard_edit_media.confirm": "Odbaciti",
  "confirmations.discard_edit_media.message": "Postoje nespremljene promjene u opisu medija ili u pretpregledu, svejedno ih odbaciti?",
  "confirmations.logout.confirm": "Odjavi se",
  "confirmations.logout.message": "Jeste li sigurni da se želite odjaviti?",
  "confirmations.mute.confirm": "Utišaj",
  "confirmations.redraft.confirm": "Izbriši i ponovno uredi",
  "confirmations.unfollow.confirm": "Prestani pratiti",
  "conversation.delete": "Izbriši razgovor",
  "conversation.mark_as_read": "Označi kao pročitano",
  "conversation.open": "Prikaži razgovor",
  "conversation.with": "S {names}",
  "copypaste.copied": "Kopirano",
  "copypaste.copy_to_clipboard": "Kopiraj u međuspremnik",
  "directory.federated": "Iz znanog fediversa",
  "directory.local": "Samo iz {domain}",
  "directory.new_arrivals": "Novi korisnici",
  "directory.recently_active": "Nedavno aktivni",
  "disabled_account_banner.account_settings": "Postavke računa",
  "disabled_account_banner.text": "Tvoj račun {disabledAccount} je trenutno onemogućen.",
  "embed.instructions": "Embed this status on your website by copying the code below.",
  "embed.preview": "Evo kako će izgledati:",
  "emoji_button.activity": "Aktivnost",
  "emoji_button.clear": "Obriši",
  "emoji_button.custom": "Prilagođeno",
  "emoji_button.flags": "Zastave",
  "emoji_button.food": "Hrana i piće",
  "emoji_button.label": "Umetni emotikone",
  "emoji_button.nature": "Priroda",
  "emoji_button.not_found": "Nema emotikona!! (╯°□°）╯︵ ┻━┻",
  "emoji_button.objects": "Predmeti",
  "emoji_button.people": "Ljudi",
  "emoji_button.recent": "Često korišteno",
  "emoji_button.search": "Traži...",
  "emoji_button.search_results": "Rezultati pretraživanja",
  "emoji_button.symbols": "Simboli",
  "emoji_button.travel": "Putovanje i mjesta",
  "empty_column.account_suspended": "Račun je suspendiran",
  "empty_column.account_timeline": "Ovdje nema tootova!",
  "empty_column.account_unavailable": "Profil nije dostupan",
  "empty_column.blocks": "Još niste blokirali nikoga.",
  "empty_column.bookmarked_statuses": "Još nemaš niti jedan označeni toot. Kada označiš jedan, prikazat će se ovdje.",
  "empty_column.community": "Lokalna vremenska crta je prazna. Napišite nešto javno da biste pokrenuli stvari!",
  "empty_column.domain_blocks": "Još nema blokiranih domena.",
  "empty_column.follow_requests": "Nemaš niti jedan zahtjev za praćenjem. Ako ga dobiješ, prikazat će se ovdje.",
  "empty_column.hashtag": "Još ne postoji ništa s ovim hashtagom.",
  "empty_column.home": "Vaša početna vremenska crta je prazna! Posjetite {public} ili koristite tražilicu kako biste započeli i upoznali druge korisnike.",
  "empty_column.list": "Na ovoj listi još nema ničega. Kada članovi ove liste objave nove tootove, oni će se pojaviti ovdje.",
  "empty_column.mutes": "Niste utišali nijednog korisnika.",
  "empty_column.notifications": "Još nemate obavijesti. Komunicirajte s drugima kako biste započeli razgovor.",
  "empty_column.public": "Ovdje nema ništa! Napišite nešto javno ili ručno pratite korisnike s drugi poslužitelja da biste ovo popunili",
  "error.unexpected_crash.explanation": "Zbog bug-a u našem kodu ili zbog nekompatibilnosti pretraživača, ova stranica se ne može prikazati ispravno.",
  "error.unexpected_crash.explanation_addons": "Ova stranica ne može biti ispravno prikazana. Ova greška je uzrokovana dodatkom za browser ili alatom za automatsko prevođenje.",
  "error.unexpected_crash.next_steps": "Pokušaj osvježiti stranicu. Ako to ne pomogne, i dalje ćeš biti u mogućnosti koristiti Mastodon preko nekod drugog preglednika ili izvornog app-a.",
  "error.unexpected_crash.next_steps_addons": "Pokušaj ih onemogućiti i osvježiti stranicu. Ako to ne pomogne, i dalje ćeš biti u mogućnosti koristiti Mastodon preko nekog drugog preglednika ili izvornog app-a.",
  "errors.unexpected_crash.copy_stacktrace": "Kopiraj stacktrace u međuspremnik",
  "errors.unexpected_crash.report_issue": "Prijavi problem",
  "explore.suggested_follows": "Ljudi",
  "explore.trending_links": "Novosti",
  "explore.trending_statuses": "Objave",
  "explore.trending_tags": "Hashtagovi",
  "filter_modal.added.context_mismatch_title": "Nepodudaranje konteksta!",
  "filter_modal.added.review_and_configure_title": "Postavke filtara",
  "filter_modal.added.title": "Filtar dodan!",
  "filter_modal.select_filter.prompt_new": "Nova kategorija: {name}",
  "filter_modal.select_filter.search": "Pretraži ili stvori",
  "filter_modal.select_filter.subtitle": "Odaberite postojeću kategoriju ili stvorite novu",
  "filter_modal.select_filter.title": "Filtriraj ovu objavu",
  "filter_modal.title.status": "Filtriraj objavu",
  "firehose.all": "Sve",
  "firehose.local": "Ovaj server",
  "firehose.remote": "Drugi serveri",
  "follow_request.authorize": "Autoriziraj",
  "follow_request.reject": "Odbij",
  "footer.about": "O aplikaciji",
  "footer.directory": "Direktorij profila",
  "footer.get_app": "Preuzmi aplikaciju",
  "footer.keyboard_shortcuts": "Tipkovni prečaci",
  "footer.privacy_policy": "Pravila o zaštiti privatnosti",
  "footer.source_code": "Prikaz izvornog koda",
  "footer.status": "Stanje",
  "generic.saved": "Spremljeno",
  "getting_started.heading": "Počnimo",
  "hashtag.column_header.tag_mode.all": "i {additional}",
  "hashtag.column_header.tag_mode.any": "ili {additional}",
  "hashtag.column_header.tag_mode.none": "bez {additional}",
  "hashtag.column_settings.select.no_options_message": "Nisu pronađeni prijedlozi",
  "hashtag.column_settings.select.placeholder": "Unesite hashtagove…",
  "hashtag.column_settings.tag_mode.all": "Sve navedeno",
  "hashtag.column_settings.tag_mode.any": "Bilo koji navedeni",
  "hashtag.column_settings.tag_mode.none": "Nijedan navedeni",
  "hashtag.column_settings.tag_toggle": "Uključi dodatne oznake za ovaj stupac",
  "hashtag.follow": "Prati hashtag",
  "hashtag.unfollow": "Prestani pratiti hashtag",
  "home.column_settings.show_reblogs": "Pokaži boostove",
  "home.column_settings.show_replies": "Pokaži odgovore",
  "home.hide_announcements": "Sakrij najave",
  "home.pending_critical_update.title": "Dostupno je kritično sigurnosno ažuriranje!",
  "home.show_announcements": "Prikaži najave",
  "interaction_modal.on_this_server": "Na ovom serveru",
  "intervals.full.days": "{number, plural, one {# dan} other {# dana}}",
  "intervals.full.hours": "{number, plural, one {# sat} few {# sata} other {# sati}}",
  "intervals.full.minutes": "{number, plural, one {# minuta} few {# minute} other {# minuta}}",
  "keyboard_shortcuts.back": "za vraćanje natrag",
  "keyboard_shortcuts.blocked": "za otvaranje liste blokiranih korisnika",
  "keyboard_shortcuts.boost": "za boostanje",
  "keyboard_shortcuts.column": "za fokusiranje na toot u jednom od stupaca",
  "keyboard_shortcuts.compose": "za fokusiranje na tekstualni okvir za stvaranje",
  "keyboard_shortcuts.description": "Opis",
  "keyboard_shortcuts.down": "za pomak dolje na listi",
  "keyboard_shortcuts.enter": "za otvaranje toota",
  "keyboard_shortcuts.favourites": "Otvori listu omiljenih",
  "keyboard_shortcuts.federated": "za otvaranje federalne vremenske crte",
  "keyboard_shortcuts.heading": "Tipkovnički prečaci",
  "keyboard_shortcuts.home": "za otvaranje početne vremenske crte",
  "keyboard_shortcuts.hotkey": "Tipkovnički prečac",
  "keyboard_shortcuts.legend": "za prikaz ove legende",
  "keyboard_shortcuts.local": "za otvaranje lokalne vremenske crte",
  "keyboard_shortcuts.mention": "za spominjanje autora",
  "keyboard_shortcuts.muted": "za otvaranje liste utišanih korisnika",
  "keyboard_shortcuts.my_profile": "za otvaranje Vašeg profila",
  "keyboard_shortcuts.notifications": "za otvaranje stupca s obavijestima",
  "keyboard_shortcuts.open_media": "za otvaranje medijskog sadržaja",
  "keyboard_shortcuts.pinned": "za otvaranje liste prikvačenih tootova",
  "keyboard_shortcuts.profile": "za otvaranje autorovog profila",
  "keyboard_shortcuts.reply": "za odgovaranje",
  "keyboard_shortcuts.requests": "za otvaranje liste zahtjeva za praćenje",
  "keyboard_shortcuts.search": "za fokusiranje na tražilicu",
  "keyboard_shortcuts.spoilers": "to show/hide CW field",
  "keyboard_shortcuts.start": "to open \"get started\" column",
  "keyboard_shortcuts.toggle_hidden": "to show/hide text behind CW",
  "keyboard_shortcuts.toggle_sensitivity": "za prikaz/sakrivanje medijskog sadržaja",
  "keyboard_shortcuts.toot": "za započinjanje novog toota",
  "keyboard_shortcuts.unfocus": "to un-focus compose textarea/search",
  "keyboard_shortcuts.up": "to move up in the list",
  "lightbox.close": "Zatvori",
  "lightbox.next": "Sljedeće",
  "lightbox.previous": "Prethodno",
  "limited_account_hint.action": "Svejedno prikaži profil",
  "lists.delete": "Izbriši listu",
  "lists.edit": "Uredi listu",
  "lists.replies_policy.followed": "Bilo koji praćeni korisnik",
  "lists.replies_policy.list": "Članovi liste",
  "lists.replies_policy.none": "Nitko",
  "navigation_bar.about": "O aplikaciji",
  "navigation_bar.advanced_interface": "Otvori u naprednom web sučelju",
  "navigation_bar.blocks": "Blokirani korisnici",
  "navigation_bar.direct": "Privatna spominjanja",
  "navigation_bar.domain_blocks": "Blokirane domene",
  "navigation_bar.favourites": "Favoriti",
  "navigation_bar.filters": "Utišane riječi",
  "navigation_bar.follow_requests": "Zahtjevi za praćenje",
  "navigation_bar.follows_and_followers": "Praćeni i pratitelji",
  "navigation_bar.lists": "Liste",
  "navigation_bar.logout": "Odjavi se",
  "navigation_bar.mutes": "Utišani korisnici",
  "navigation_bar.preferences": "Postavke",
  "navigation_bar.search": "Traži",
  "not_signed_in_indicator.not_signed_in": "You need to sign in to access this resource.",
  "notification.follow": "{name} Vas je počeo/la pratiti",
  "notification.follow_request": "{name} zatražio/la je da Vas prati",
  "notification.own_poll": "Vaša anketa je završila",
  "notification.reblog": "{name} je boostao/la Vaš status",
  "notifications.clear": "Očisti obavijesti",
  "notifications.clear_confirmation": "Želite li zaista trajno očistiti sve Vaše obavijesti?",
  "notifications.column_settings.alert": "Obavijesti radne površine",
  "notifications.column_settings.follow": "Novi pratitelji:",
  "notifications.column_settings.follow_request": "Novi zahtjevi za praćenje:",
  "notifications.column_settings.mention": "Spominjanja:",
  "notifications.column_settings.poll": "Rezultati anketa:",
  "notifications.column_settings.push": "Push obavijesti",
  "notifications.column_settings.reblog": "Boostovi:",
  "notifications.column_settings.show": "Prikaži u stupcu",
  "notifications.column_settings.sound": "Sviraj zvuk",
  "notifications.column_settings.status": "New toots:",
  "notifications.filter.all": "Sve",
  "notifications.filter.boosts": "Boostovi",
  "notifications.filter.follows": "Praćenja",
  "notifications.filter.mentions": "Spominjanja",
  "notifications.filter.polls": "Rezultati anketa",
  "notifications.grant_permission": "Odobri dopuštenje.",
  "notifications.group": "{count} obavijesti",
  "notifications.mark_as_read": "Označi sve obavijesti kao pročitane",
  "onboarding.profile.upload_avatar": "Učitaj sliku profila",
  "poll.closed": "Završeno",
  "poll.refresh": "Osvježi",
  "poll.reveal": "Vidi rezultate",
  "poll.total_people": "{count, plural, one {# osoba} few {# osobe} other {# osoba}}",
  "poll.total_votes": "{count, plural, one {# glas} few {# glasa} other {# glasova}}",
  "poll.vote": "Glasaj",
  "poll.voted": "Vi ste glasali za ovaj odgovor",
  "poll_button.add_poll": "Dodaj anketu",
  "poll_button.remove_poll": "Ukloni anketu",
  "privacy.change": "Podesi privatnost toota",
  "privacy.public.short": "Javno",
  "privacy_policy.last_updated": "Zadnje ažurirannje {date}",
  "privacy_policy.title": "Pravila o zaštiti privatnosti",
  "recommended": "Preporučeno",
  "refresh": "Osvježi",
  "relative_time.days": "{number}d",
  "relative_time.full.just_now": "upravo sad",
  "relative_time.just_now": "sada",
  "relative_time.today": "danas",
  "reply_indicator.cancel": "Otkaži",
  "report.block": "Blokiraj",
  "report.block_explanation": "Nećete vidjeti njihove objave. Oni neće vidjeti vaše objave i neće vas moći pratiti. Moći će vidjeti da su blokirani.",
  "report.categories.other": "Drugo",
  "report.categories.spam": "Spam",
  "report.categories.violation": "Sadržaj krši jedno ili više pravila poslužitelja",
  "report.category.title": "Recite nam što nije u redu s {type}",
  "report.category.title_account": "profilom",
  "report.category.title_status": "objavom",
  "report.close": "Gotovo",
  "report.comment.title": "Postoji li još nešto što bismo trebali znati?",
  "report.forward": "Proslijedi {target}",
  "report.forward_hint": "Račun je s drugog poslužitelja. Poslati anonimiziranu kopiju prijave i tamo?",
  "report.mute": "Utišaj",
  "report.mute_explanation": "Nećete vidjeti njihove objave. Oni će vas i dalje moći pratiti i vidjeti vaše objave i neće znati da su utišani.",
  "report.next": "Sljedeće",
  "report.placeholder": "Dodatni komentari",
  "report.reasons.dislike": "Ne sviđa mi se",
  "report.reasons.dislike_description": "Nije nešto što želiš vidjeti",
  "report.reasons.other": "Nešto drugo",
  "report.reasons.other_description": "Problem ne spada u nijednu drugu kategoriju",
  "report.reasons.spam": "Spam je",
  "report.reasons.spam_description": "Zlonamjerne poveznice, lažni angažman ili repetitivni odgovori",
  "report.submit": "Pošalji",
  "report.target": "Prijavljivanje korisnika {target}",
  "report.thanks.title": "Ne želiš vidjeti ovo?",
  "report_notification.attached_statuses": "{count, plural, one {# post} other {# posts}} attached",
  "report_notification.categories.other": "Drugo",
  "report_notification.categories.spam": "Spam",
  "report_notification.categories.violation": "Povreda pravila",
  "report_notification.open": "Otvori izvješće",
  "search.no_recent_searches": "Nema nedavnih pretraga",
  "search.placeholder": "Traži",
  "search.quick_action.go_to_account": "Idi na profil {x}",
  "search.quick_action.open_url": "Otvori link u Mastodonu",
  "search.search_or_paste": "Pretraži ili zalijepi URL",
  "search_popout.full_text_search_disabled_message": "Nije dostuppno na {domain}.",
  "search_popout.language_code": "ISO jezični kod",
  "search_popout.options": "Opcije pretraživanja",
  "search_popout.quick_actions": "Brze radnje",
  "search_popout.recent": "Nedavne pretrage",
  "search_popout.specific_date": "specifičan datum",
  "search_popout.user": "korisnik",
  "search_results.accounts": "Profili",
  "search_results.all": "Sve",
  "search_results.see_all": "Prikaži sve",
  "search_results.statuses": "Toots",
  "server_banner.about_active_users": "Popis aktivnih korisnika prošli mjesec",
  "server_banner.active_users": "aktivni korisnici",
  "server_banner.administered_by": "Administrator je:",
  "server_banner.server_stats": "Statistike poslužitelja:",
  "sign_in_banner.create_account": "Stvori račun",
  "sign_in_banner.sign_in": "Prijavi se",
  "sign_in_banner.sso_redirect": "Prijava ili registracija",
  "status.admin_status": "Open this status in the moderation interface",
  "status.block": "Blokiraj @{name}",
  "status.bookmark": "Dodaj u favorite",
  "status.cannot_reblog": "Ova objava ne može biti boostana",
  "status.copy": "Copy link to status",
  "status.delete": "Obriši",
  "status.edit": "Uredi",
  "status.edited_x_times": "Edited {count, plural, one {# time} other {# times}}",
  "status.filter": "Filtriraj ovu objavu",
  "status.history.created": "Kreirao/la {name} prije {date}",
  "status.history.edited": "Uredio/la {name} prije {date}",
  "status.load_more": "Učitaj više",
  "status.media.open": "Kliknite za otvaranje",
  "status.media_hidden": "Sakriven medijski sadržaj",
  "status.mention": "Spomeni @{name}",
  "status.more": "Više",
  "status.mute": "Utišaj @{name}",
  "status.mute_conversation": "Utišaj razgovor",
  "status.open": "Proširi ovaj toot",
  "status.pin": "Prikvači na profil",
  "status.read_more": "Pročitajte više",
  "status.reblog": "Boostaj",
  "status.reblogged_by": "{name} je boostao/la",
  "status.reblogs.empty": "Nitko još nije boostao ovaj toot. Kada netko to učini, ovdje će biti prikazani.",
  "status.redraft": "Izbriši i ponovno uredi",
  "status.remove_bookmark": "Ukloni knjižnu oznaku",
  "status.replied_to": "Odgovorio/la je {name}",
  "status.reply": "Odgovori",
  "status.replyAll": "Odgovori na niz",
  "status.report": "Prijavi @{name}",
  "status.sensitive_warning": "Osjetljiv sadržaj",
  "status.share": "Podijeli",
  "status.show_original": "Prikaži original",
  "status.title.with_attachments": "{user} posted {attachmentCount, plural, one {an attachment} other {# attachments}}",
  "status.translate": "Prevedi",
  "status.translated_from_with": "Prevedno s {lang} koristeći {provider}",
  "status.uncached_media_warning": "Pregled nije dostupan",
  "status.unmute_conversation": "Poništi utišavanje razgovora",
  "status.unpin": "Otkvači s profila",
  "subscribed_languages.save": "Spremi promjene",
  "tabs_bar.home": "Početna",
  "tabs_bar.notifications": "Obavijesti",
  "time_remaining.days": "{number, plural, one {preostao # dan} other {preostalo # dana}}",
  "time_remaining.hours": "{number, plural, one {preostao # sat} few {preostalo # sata} other {preostalo # sati}}",
  "time_remaining.minutes": "{number, plural, one {preostala # minuta} few {preostale # minute} other {preostalo # minuta}}",
  "time_remaining.seconds": "{number, plural, one {preostala # sekunda} few {preostale # sekunde} other {preostalo # sekundi}}",
  "trends.counter_by_accounts": "{count, plural, one {{counter} person} other {{counter} people}} in the past {days, plural, one {day} other {# days}}",
  "trends.trending_now": "Popularno",
  "ui.beforeunload": "Vaša skica bit će izgubljena ako napustite Mastodon.",
  "units.short.billion": "{count} mlrd.",
  "units.short.million": "{count} mil.",
  "units.short.thousand": "{count} tis.",
  "upload_area.title": "Povucite i ispustite za prijenos",
  "upload_button.label": "Dodajte slike, video ili audio datoteku",
  "upload_error.limit": "Ograničenje prijenosa datoteka je prekoračeno.",
  "upload_error.poll": "Prijenos datoteka nije dopušten kod anketa.",
  "upload_form.edit": "Uredi",
  "upload_progress.label": "Prenošenje...",
  "upload_progress.processing": "Obrada…",
  "video.close": "Zatvori video",
  "video.download": "Preuzmi datoteku",
  "video.exit_fullscreen": "Izađi iz cijelog zaslona",
  "video.expand": "Proširi video",
  "video.fullscreen": "Cijeli zaslon",
  "video.hide": "Sakrij video",
  "video.pause": "Pauziraj",
  "video.play": "Reproduciraj"
}
